import React from 'react';
import classNames from 'classnames';
import { round } from 'lodash';

type DrawingPathSvgProps = {
    className?: string;
    color?: string;
    getStrokeColor: (color?: string) => string | undefined;
    isStrokeOnly?: boolean;
    size?: number;
    svgPath?: string;
} & Omit<React.SVGProps<SVGPathElement>, 'color'>;

const DrawingPathSvg: React.FC<DrawingPathSvgProps> = ({
    className,
    color,
    getStrokeColor,
    isStrokeOnly,
    size,
    svgPath,
    ...rest
}) => {
    if (!svgPath) return null;

    if (isStrokeOnly) {
        return (
            <path
                className={classNames('stroke-only', className)}
                stroke={getStrokeColor(color)}
                strokeWidth={round(size ?? 1, 1)}
                fill="none"
                strokeLinecap="round"
                d={svgPath}
                {...rest}
            />
        );
    }

    return <path className={className} fill={getStrokeColor(color)} d={svgPath} {...rest} />;
};

export default DrawingPathSvg;
